<template>

  <v-card>
    <v-card-text>
      <video ref="camera"></video>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text @click="ok()">
        {{ $t('files.capture') }}
      </v-btn>

      <v-btn v-if="multicam" @click="switchCamera()">
        {{ $t('files.switch-image') }}
      </v-btn>

      <v-btn text @click="close()">
        {{ $t('cancel') }}
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
  export default {
    name: 'camera-dialog',

    data () {
      return {
        size: { width: 0, height: 0 }
      }
    },

    computed: {
      multicam () {
        return (this.$store.state.mediaDevices || []).filter(device => device.kind === 'videoinput').length > 1
      },
    },

    methods: {
      ok () {
        const snapshot = document.createElement('canvas')
        const video = this.$refs.camera

        snapshot.width = video.videoWidth
        snapshot.height = video.videoHeight

        const context = snapshot.getContext('2d')

        context.drawImage(video, 0, 0)
        snapshot.toBlob(blob => {
          this.$emit('submit', new File([blob], 'camera.png'))
        })
      },

      close () {
        this.$emit('submit', false)
      },
    },

    async mounted () {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)
        return

      const videoConstraint = this.multicam ? { facingMode: { ideal: 'environment' } } : true
      const stream = await navigator.mediaDevices.getUserMedia({ video: videoConstraint })
      const video = this.$refs.camera
      window.cameraStream = stream

      video.srcObject = stream
      await video.play()

      this.size = { width: video.videoWidth, height: video.videoHeight }
    },

    beforeDestroy() {
      if (window.cameraStream)
        window.cameraStream.getVideoTracks().forEach((track) => track.stop())
    }
  }
</script>

<style scoped lang="scss">

  video {
    width: 100%;
  }

  .v-card__text {
    padding: 0;
  }

</style>
